export interface IHit {
	id: string,
	url: string,
	name: string,
	party: string,
	boards: string[],
	image: string,
}

export interface ISearchParams {
    query: string
    page: number
    board: string,
    party: string,
}

export interface ISearchResult {
	hits: IHit[],
	total: number,
	query: string,
	page: number,
}

export interface IFilter {
	type: string,
	name: string,
	options: string[]
}

export interface IState {
	loading: boolean,
	count: number,
	query: string,
	page: number,
	filters: IFilter[],
	searchUrl: string,
	hits: IHit[],
	total: number,
	selectedBoard: string,
	selectedParty: string,
	defaultImage: string,
	isSearch: boolean,
}

const deafultState: IState = {
	loading: false,
	count: 0,
	query: '',
	page: 1,
	filters: [],
	searchUrl: '',
	hits: [],
	total: 0,
	selectedBoard: '',
	selectedParty: '',
	defaultImage: '',
	isSearch: false,
}

export default deafultState;
